var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpsFair(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D91E",
    fillRule: "nonzero",
    d: "M14.94 31.107C6.775 31.006.136 24.366 0 16.167h2.44c.135 6.844 5.656 12.366 12.5 12.501v2.44zm0-4.336c-5.793-.102-10.468-4.777-10.604-10.603h2.44c.1 4.437 3.692 8.028 8.164 8.164v2.439z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D91E",
    fillRule: "nonzero",
    d: "M14.94 22.435a6.494 6.494 0 0 1-6.234-6.233l2.405-.034a4.037 4.037 0 0 0 3.829 3.828v2.439z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13.432 15.432a1.412 1.412 0 0 1 2.033 0 1.412 1.412 0 0 1 0 2.033 1.412 1.412 0 0 1-2.033 0 1.412 1.412 0 0 1 0-2.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.426 0c-.344 0-.688.131-.95.394l-1.683 1.683a1.343 1.343 0 0 0 0 1.9l4.533 4.532 3.582-3.583L15.376.394a1.339 1.339 0 0 0-.95-.394zM24.68 3.583c-.458 0-.916.175-1.266.525l-5.22 5.218a1.788 1.788 0 0 0-.047 2.475 3.135 3.135 0 0 0-3.165.765l4.452 4.452a3.137 3.137 0 0 0 .765-3.165 1.787 1.787 0 0 0 2.473-.049l5.22-5.218c.7-.699.7-1.834 0-2.533l-1.945-1.945a1.786 1.786 0 0 0-1.266-.525zM27.074 12.092l-3.583 3.582 4.533 4.533a1.343 1.343 0 0 0 1.9 0l1.682-1.683a1.343 1.343 0 0 0 0-1.9l-4.532-4.532z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsFair);
export default __webpack_public_path__ + "static/media/gps_fair.8361895e5f05e1df8e6998b3dd1bd135.svg";
export { ForwardRef as ReactComponent };